import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const CropIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.6", ...props.sx}} viewBox="0 0 12 14">
        <path
            d="M0.75 13C0.75 13 2.25 13 3.46618 12.1749C4.68236 11.3498 5.75 9.5 5.75 9.5M8.78815 1.00145C8.62252 1.0433 8.95377 2.13154 7.46312 2.59194C5.97247 3.05235 4.46414 2.66402 2.64884 4.49898C0.892092 6.27475 0.657855 9.47112 2.70739 11.5429C4.75693 13.6146 7.86062 13.3374 9.65767 11.5908C11.0357 10.2514 11.521 8.36798 11.1069 5.94036C10.4021 1.80832 8.95377 0.95959 8.78815 1.00145Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
